exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".section-header[data-v-f134d220]{font-weight:700;font-size:25px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/System/SystemSettings.vue"],"names":[],"mappings":"AACA,iCACI,gBAAkB,AAClB,cAAgB,CACnB","file":"SystemSettings.vue","sourcesContent":["\n.section-header[data-v-f134d220] {\n    font-weight: bold;\n    font-size: 25px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f134d220","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/System/SystemSettings.vue
// module id = 2267
// module chunks = 16